<template>
  <div class="main_box">
    <el-radio-group
      v-model="watchTarget"
      size="small"
      style="margin: 15px 0px 0px 0px"
      @change="changeWatch()"
    >
      <el-radio-button label="progress" v-if="voteType !== 3">
        监控
      </el-radio-button>
      <el-radio-button label="result">结果</el-radio-button>
      <!-- <el-radio-button label="detail">明细_v1</el-radio-button> -->
      <el-radio-button label="details">明细</el-radio-button>
      <el-radio-button label="scoreDetails" v-if="voteType === 2">
        打分细项明细
      </el-radio-button>
    </el-radio-group>
    <router-view />
  </div>
</template>

<script>
export default {
  data () {
    return {
      watchTarget: 'progress',
      voteType: -1
    }
  },
  methods: {
    changeWatch: function () {
      switch (this.watchTarget) {
        case 'progress':
          this.$router.push({ name: 'voteProgress', params: { mid: this.$route.params.mid, vid: this.$route.params.vid, votetype: this.$route.params.votetype } })
          break
        case 'result':
          if (this.voteType === 3) {
            this.$router.push({ name: 'voteScreenResult', params: { mid: this.$route.params.mid, vid: this.$route.params.vid, votetype: this.$route.params.votetype } })
          } else {
            this.$router.push({ name: 'voteResult', params: { mid: this.$route.params.mid, vid: this.$route.params.vid, votetype: this.$route.params.votetype } })
          }
          break
        case 'detail':
          this.$router.push({ name: 'voteDetail', params: { mid: this.$route.params.mid, vid: this.$route.params.vid, votetype: this.$route.params.votetype } })
          break
        case 'details':
          this.$router.push({ name: 'voteDetails', params: { mid: this.$route.params.mid, vid: this.$route.params.vid, votetype: this.$route.params.votetype } })
          break
        case 'scoreDetails':
          this.$router.push({ name: 'voteScoreDetails', params: { mid: this.$route.params.mid, vid: this.$route.params.vid, votetype: this.$route.params.votetype } })
          break
      }
    }
  },
  mounted () {
  },
  created () {
    this.voteType = parseInt(this.$route.params.votetype)
    if (this.voteType === 3) {
      this.watchTarget = 'result'
    }
    if (this.$route.name === 'voteProgress') {
      this.watchTarget = 'progress'
    } else if (this.$route.name === 'voteResult') {
      this.watchTarget = 'result'
    } else if (this.$route.name === 'voteDetail') {
      this.watchTarget = 'detail'
    } else if (this.$route.name === 'voteDetails') {
      this.watchTarget = 'details'
    } else if (this.$route.name === 'voteScoreDetails') {
      this.watchTarget = 'scoreDetails'
    } else {
      this.changeWatch()
    }
  }
}
</script>
<style lang="less">
</style>
